// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.alert-modal-content {
  background-color: #011029;
  border-radius: 8px;
  min-width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.alert-modal-header {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.alert-modal-header.success {
  color: #4caf50;
}

.alert-modal-header.error {
  color: #f44336;
}

.alert-modal-header.info {
  color: #2196F3;
}

.alert-modal-header.confirm {
  color: #ff9800;
}

.alert-modal-body {
  padding: 24px;
  color: white;
  font-size: 16px;
  line-height: 1.5;
}

.alert-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.alert-modal-button {
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  background-color: #2196F3;
  color: white;
  transition: background-color 0.2s;
}

.alert-modal-button:hover {
  background-color: #1976D2;
}

.alert-modal-button.confirm {
  background-color: #4caf50;
}

.alert-modal-button.confirm:hover {
  background-color: #388e3c;
}

.alert-modal-button.cancel {
  background-color: #f44336;
}

.alert-modal-button.cancel:hover {
  background-color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/AlertModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".alert-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.alert-modal-content {\n  background-color: #011029;\n  border-radius: 8px;\n  min-width: 400px;\n  max-width: 90%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.alert-modal-header {\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n}\n\n.alert-modal-header.success {\n  color: #4caf50;\n}\n\n.alert-modal-header.error {\n  color: #f44336;\n}\n\n.alert-modal-header.info {\n  color: #2196F3;\n}\n\n.alert-modal-header.confirm {\n  color: #ff9800;\n}\n\n.alert-modal-body {\n  padding: 24px;\n  color: white;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.alert-modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.alert-modal-button {\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  background-color: #2196F3;\n  color: white;\n  transition: background-color 0.2s;\n}\n\n.alert-modal-button:hover {\n  background-color: #1976D2;\n}\n\n.alert-modal-button.confirm {\n  background-color: #4caf50;\n}\n\n.alert-modal-button.confirm:hover {\n  background-color: #388e3c;\n}\n\n.alert-modal-button.cancel {\n  background-color: #f44336;\n}\n\n.alert-modal-button.cancel:hover {\n  background-color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
